import { Box } from "@mui/material";
import { PrimaryTooltip } from "../StyledComponent";
import PingStatusDefinition from "./PingStatusDefinition";
import { getDotStatus } from "./pingStatusDefinitions";

// Wraps an online/offline dot so hovering it explains the dot's own state.
// online: whether the dot shows online; leave it out to explain both states.
const PingStatusTooltip = ({ children, online, entityLabel, placement = "top" }) => (
  <PrimaryTooltip
    title={<PingStatusDefinition status={getDotStatus(online)} entityLabel={entityLabel} />}
    placement={placement}
  >
    <Box
      component="span"
      data-testid="ping-status-dot"
      sx={{ display: "inline-flex", alignItems: "center", cursor: "default" }}
    >
      {children}
    </Box>
  </PrimaryTooltip>
);

export default PingStatusTooltip;
